<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="row left-right-row">
                    <div class="left" />
                    <div class="right">
                        <router-link
                            class="btn btn-success"
                            to="/office/postcode-fees/new"
                        >
                            <i class="fa fa-plus" /> New Postcode
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <table
                            class="table"
                            v-if="!loading && postcodes.length"
                        >
                            <thead>
                                <tr>
                                    <th>Postcode</th>
                                    <th>Area</th>
                                    <th>Service Fee</th>
                                    <th>Unit Price</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(postcode, index) in postcodes"
                                    :key="index"
                                >
                                    <td>
                                        <router-link :to="{name: 'office.postcode_fees.edit', params: { id: postcode.id } }">
                                            {{ postcode.postcode }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <router-link :to="{name: 'office.postcode_fees.edit', params: { id: postcode.id } }">
                                            {{ postcode.area_name || '-' }}
                                        </router-link>
                                    </td>
                                    <td>
                                        {{ postcode.service_fee }}
                                    </td>
                                    <td>
                                        {{ postcode.unit_fee }}
                                    </td>
                                    <td class="text-right">
                                        <router-link
                                            :to="{name: 'office.postcode_fees.edit', params: { id: postcode.id } }"
                                            class="row-icon"
                                        >
                                            <i class="fa fa-pencil-alt" />
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-if="!loading && postcodes.length === 0">
                            No postcodes to show
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Service from "../../../services/PostcodeFeeService";

export default {
    data: function() {
        return {
            postcodes: [],
            loading: false
        };
    },
    mounted: function() {
        this.loading = true;
        Service.search().then(
            res => {
                this.postcodes = res.data;
                this.loading = false;
            },
            err => {
                this.loading = false;
                alert("Error: Could not load postcodes");
                console.error(err);
            }
        );
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/office/postcode-fees/SearchComponent.vue